<template>
  <b-col class="px-sm-0 pl-xl-3 mt-lg-3 mt-xl-0 col-12 col-xl-10">
    <fieldset class="border border-primary p-2 rounded mt-3 ">
      <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Template Credentials</legend>
      <b-form-group
        class=""
        label-for="">
        <div class="credentials row">
          <div class="credential-field col-12 col-md-6 col-lg-4 col-xl-3" @click="clearErrors('username')">
            <div>
              <label>Account Username<span class='star'>*</span></label>
            </div>
            <b-form-input
            name="username"
            type="text"
            v-model.trim="form.username"
            ></b-form-input>
            <div class="errorsection">
              <label class="text-error-msg" :style="{'visibility':errorFields.usernameError ? 'visible' : 'hidden'}">{{ errorFields.usernameError }}</label>
            </div>
          </div>
          <div class="credential-field col-12 col-md-6 col-lg-4 col-xl-3" @click="clearErrors('newPassword')">
            <div>
              <label>Auto Template Id</label>
            </div>
            <div class="">
              <b-form-input
              name="autotemplateid"
              class=""
              type="text"
              v-model="form.autoTemplateId"
              ></b-form-input>
            </div>
            <div class="errorsection" >
              <label class="text-error-msg" :style="{'visibility': errorFields.autotemplateidError ? 'visible' : 'hidden'}" >{{ errorFields.autotemplateidError }}</label>
            </div>
          </div>
          <div class="credential-field col-12 col-md-6 col-lg-4 col-xl-3" @click="clearErrors('confirmPassword')">
            <div>
              <label>Property Template Id</label>
            </div>
            <div class="password-field">
              <b-form-input
              name="propertytemplateid"
              type="text"
              v-model="form.propertyTemplateId"
              ></b-form-input>
            </div>
            <div class="errorsection">
              <!-- <label class="text-error-msg" v-show="errorFields.confirmPasswordError">{{ errorFields.confirmPasswordError }}</label> -->
              <label class="text-error-msg"  :style="{'visibility': errorFields.propertytemplateidError ? 'visible' : 'hidden'}" >{{ errorFields.propertytemplateidError }}</label>
            </div>
          </div>
          <div class="credential-field col-12 col-md-6 col-lg-12 col-xl-3">
            <button @click.stop.prevent="submitTemplateId()" class="btn btn-success">
              <span class="ml-1">Save</span>
            </button>
          </div>
        </div>
      </b-form-group>
    </fieldset>
  </b-col>
</template>

<script>
/* eslint-disable */
import postData from '../../../services/postData';
import fetchData from '../../../services/fetchData';
export default {
  props: ['ezlynxcredential'],
  data() {
    return {
      name: '',
      id: '',
      selected: [], // Must be an array reference!
      form: {
        agencyId: null,
        username: '',
        autoTemplateId: null,
        propertyTemplateId: null,
      },
      errorFields: {
        usernameError: '',
        propertytemplateid: '',
        autotemplateid: '',
      },
    };
  },
  created() {
    fetchData.getDashboard(`/agencies/${this.$route.query.agencyID}/ezlynx-rater-credentials`).then((response) => {
            // this.agencyID = response.data.AgencyId;
            this.ezlynxRaterCredentialData = response.data;
            this.form.agencyId = this.ezlynxRaterCredentialData.AgencyId;
            this.form.username = this.ezlynxRaterCredentialData.AccountUserName;
            if (!this.ezlynxRaterCredentialData.AutoTemplateId) {
              this.form.autoTemplateId = '';
            } else {
              this.form.autoTemplateId = String(this.ezlynxRaterCredentialData.AutoTemplateId);
            }
            if (!this.ezlynxRaterCredentialData.PropertyTemplateId) {
              this.form.propertyTemplateId = '';
            } else {
              this.form.propertyTemplateId = String(this.ezlynxRaterCredentialData.PropertyTemplateId);
            }
        });
  },
  methods: {
    clearErrors(val) {
      // clears the error message property
      this.errorFields[`${val}Error`] = '';
    },
    submitTemplateId() {
       if (this.validateFields()) {
          // Post to new API here.
          const requestParamsCarrierLogin = {
          url: '/agencies/'+this.form.agencyId+'/ezlynx-rater-credentials',
          data: {
              AgencyId: this.form.agencyId,
              AccountUserName: this.form.username,
              AutoTemplateId: this.form.autoTemplateId,
              PropertyTemplateId: this.form.propertyTemplateId,
          },
          };
        postData.postRuleDashboard(requestParamsCarrierLogin).then((response) => {
            this.$emit("EzlynxSubmitStatus",'true');
          }).catch((error) => {
            this.$emit("EzlynxSubmitStatusFail",'true');
        });
     }
    },
    validateFields() {
      this.errorFields.usernameError = this.form.username === '' ? 'Required.' : '';
      if(this.errorFields.usernameError==='Required.') {
        return false
      }
      return true;
    },
  },
};
</script>

<style scoped>
.btn{
  text-transform: unset !important;
}
.credentials {
  display: flex;
  align-items: center;
 
}
.errorsection {
  height: 25px;
}
 .credentials LABEL {
    display: inline-flex;
    font-size: 12px;
    font-weight: 600;
  }
.password-field {
  display: flex;
  align-items: center;
}
.text-error-msg {
  font-size: 12px;
  color: #BB0000;
  font-weight: 400;
}
.revealer {
  position: relative !important;
  left: -30px !important;
 
}
.ac-carrier-container {
  display:flex;
  align-items:center;
}
img.img-fluid{
  max-width: 180px;
  height: inherit !important;
}

@media (min-width: 1200px) {
  .fieldset-width {
    width: 18%;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .fieldset-width {
    width: 30%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fieldset-width {
    width: 29.5%;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .fieldset-width {
    width: 44%;
  }
}

@media (max-width: 575px) {
  .fieldset-width {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/agencies/EzlynxTemplateLogin.vue?7e3ee03b